import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';
import { Btn, Input } from '../components/UI';
import { IconWifi } from '../components/Icons';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const toast = useToast();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      toast(err.message, 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'var(--bg)',
      backgroundImage: 'radial-gradient(ellipse 80% 50% at 50% -20%, rgba(79,142,247,0.12), transparent)',
    }}>
      {/* Grid lines decoration */}
      <div style={{ position: 'fixed', inset: 0, opacity: 0.03, backgroundImage: 'linear-gradient(var(--text) 1px, transparent 1px), linear-gradient(90deg, var(--text) 1px, transparent 1px)', backgroundSize: '40px 40px', pointerEvents: 'none' }} />

      <div style={{ width: '100%', maxWidth: 400, padding: '0 20px', animation: 'fadeUp 0.4s ease' }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 52, height: 52, borderRadius: 16, background: 'var(--accent)', marginBottom: 16, boxShadow: '0 0 30px var(--accent-glow)' }}>
            <IconWifi size={24} style={{ color: '#fff' }} />
          </div>
          <h1 style={{ fontSize: 24, fontWeight: 800, letterSpacing: '-0.03em', marginBottom: 6 }}>WiFi Portal</h1>
          <p style={{ color: 'var(--text2)', fontSize: 13 }}>Sign in to your admin account</p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 16, padding: 28, display: 'flex', flexDirection: 'column', gap: 18 }}>
          <Input label="Email Address" type="email" value={email} onChange={setEmail} placeholder="admin@example.com" required />
          <Input label="Password" type="password" value={password} onChange={setPassword} placeholder="••••••••" required />
          <Btn type="submit" loading={loading} size="lg" style={{ width: '100%', marginTop: 4 }}>
            Sign In
          </Btn>
        </form>

        <p style={{ textAlign: 'center', color: 'var(--text3)', fontSize: 11, marginTop: 20 }}>
          WiFi Portal Admin Panel — Restricted Access
        </p>
      </div>
    </div>
  );
}
